function setEqualCompareBottomHeight() {
	if (window.innerWidth <= 615) return;
	
	const compare = document.querySelector('#compare');
	if (!compare) return;
	
	const bottoms = compare.querySelectorAll('.compare__bottom');
	if (!bottoms.length) return;
	
	let maxHeight = 0;
	
	bottoms.forEach(el => {
		el.style.minHeight = '';
		const height = el.offsetHeight;
		if (height > maxHeight) maxHeight = height;
	});
	
	bottoms.forEach(el => {
		el.style.minHeight = maxHeight + 'px';
	});
}

window.addEventListener('load', setEqualCompareBottomHeight);
window.addEventListener('resize', setEqualCompareBottomHeight);